/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpDiskTarget } from '../models/GcpDiskTarget';

export class GcpDiskRestoreDestination {
  'gcpDisk'?: GcpDiskTarget;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "gcpDisk",
      "baseName": "gcpDisk",
      "type": "GcpDiskTarget",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpDiskRestoreDestination.attributeTypeMap;
  }

  public constructor() {
  }
}

